<template>
  <div class="main-box">
    
    <div>
    <h1>Welcome to Liveops Checkpoint</h1>
    <p>This application can help resolve any open requests like document verification.</p>

    <router-link to="/requests">
      <button color="primary">Check Active Requests</button>
    </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomePage',
}
</script>